import LocalizedStrings from "react-localization";

const LocaleStrings = new LocalizedStrings({
  nl: {
    country: "Land",
    //Login
    welcome_text: "Welkom terug bij ",
    enter_login_details_text: "Gelieve uw inloggegevens in te voeren",

    //Signup
    signup_title_signup: "Registreren",
    signup_subtitle: "Laten we beginnen. Vul uw gegevens in.",
    signup_form_label_fullname: "Voor- en Achternaam",
    signup_form_label_email: "Email/Badge",
    signup_form_label_password: "Password",
    signup_form_label_confpassword: "Bevestig wachtwoord",
    signup_form_validation_min_password: "Voer minimaal 6 tekens in",
    signup_form_validation_conf_password: "Wachtwoorden komen niet overeen",
    signup_error_registration_failed: "Your registration failed, try again!",
    signup_error_check_age_conditions: "Please check the age!",
    signup_text_already_an_account: "Heb je al een account?",
    signup_form_label_age: "ik ben ouder van 18 jaar",

    signup_user_form_label_username: "What do your student call you?",
    signup_user_form_ph_fname: "Enter your first name",
    signup_user_form_ph_lname: "Enter your last name",
    signup_user_stu_form_label_username: "What do your teacher call you?",
    signup_user_stu_form_ph_username: "Enter your display name",
    signup_user_form_success: "Details saved successfully!",
    signup_user_button_logout: "I'll save later. Logout",

    signup_agree_text: "Door verder te gaan gaat u akkoord met onze",
    signup_terms_text: "gebruiksvoorwaarden",
    signup_and: "en",
    signup_privacy: "Privacy Policy",

    button_save: "Opslaan",
    button_edit: "Aanpassen",
    button_delete: "Wissen",
    // Menu
    dashboard: "Dashboard",
    personalinfo: "Mijn gegevens",
    badges: "Beheer waspassen",
    numberplate: "Beheer nummerplaten",
    mytransaction: "Mijn transacties",
    profile: "Mijn profiel",
    logout: "Afmelden",
    balance_text: "Tegoed",
    valid_until: "Geldig tot",
    welcome: "Welkom",
    termsnconditions: "Algemene voorwaarden",
    privacypolicy: "Privacy policy",
    userid: "ID",

    //Dashboard
    charge_credit: "Tegoed opladen",
    number_plates: "Mijn nummerplaten",
    badges: "Waspassen",
    my_transaction: "Mijn transacties",
    manage_numberplate: "Beheer nummerplaten",
    manage_badge: "Beheer waspassen",
    make_payment_heading: "Betaling",
    make_payment_btn: "Start betaling",
    view_all: "Toon meer",
    enter_amount: "Geef bedrag in",
    bought: "Aangekocht",
    spent: "Verbruikt",

    //Personal info
    personal_info_title: "Mijn gegevens",
    invoice_info_title: "Facturatiegegevens",
    personalinfo_form_label_address: "Adres",
    personalinfo_form_label_lowcredit_notify_title:
      "Ik wil een e-mail ontvangen wanneer mijn tegoed laag is.",
    personalinfo_form_label_lowcredit_notify_amount:
      "E-mail wanneer het tegoed lager is dan",
    personalinfo_form_label_i_am_company: "Ik ben een bedrijf",
    personalinfo_form_label_company_name: "Bedrijfsnaam",
    personalinfo_form_label_tva_number: "BTW nummer",
    personalinfo_form_label_phone_number: "Telefoonnummer",
    personalinfo_form_label_billing_address: "Facturatie adres",
    personalinfo_form_label_country: "Land",
    personalinfo_form_label_notify_invoice:
      "Ik wil een factuur ontvangen via e-mail bij elke betaling.",
    personalinfo_form_label_invoice_email: "Facturatie e-mail",
    save_changes: "Wijzigingen opslaan",
    change_password_heading: "Wachtwoord wijzigen",
    change_password_btn: "Wachtwoord wijzigen",
    change_password_save: "Aanpassen",
    password_setting_form_label_old_password: "Oud wachtwoord",
    password_setting_form_ph_old_password: "Geef oud wachtwoord in",
    password_setting_form_label_new_password: "Nieuw wachtwoord",
    password_setting_form_ph_new_password: "Geef nieuw wachtwoord in",
    password_setting_form_label_repeat_password: "Herhaal wachtwoord",
    password_setting_form_ph_repeat_password: "Geef nieuw wachtwoord in",
    password_setting_form_success: "Wachtwoord is gewijzigd",
    password_setting_form_old_password_error:
      "Wachtwoord opnieuw instellen mislukt",
    password_setting_form_validation_repeat_password_required:
      "Wachtwoord komt niet overeen",
    password_setting_form_validation_repeat_old_password_not_match:
      "Wachtwoorden komen niet overeen",
    users_additional_form_label_address: "Adres",

    // Badges
    add_badge_text: "Waspas toevoegen",
    edit_badge_text: "Waspas wijzigen",
    enter_badge_number: "Geef waspas in",
    reference: "Referentie / naam",
    select_fixed_program: "Selecteer vast wasprogramma",
    badge_add: "Toevoegen",
    badge_update: "Wijzigen",
    my_badges: "Mijn waspassen",
    badge_header: "Waspas",
    reference_header: "Referentie",
    fixed_washing_program_header: "Vast wasprogramma",
    deactivate_header: "(De)activeer",
    badge_already_exist: "Waspas is al in gebruik",
    badge_added: "Waspas toegevoegd",
    badge_updated: "Waspas gewijzigd",
    badge_activate: "Waspas geactiveerd",
    badge_deactivate: "Waspas gedeactiveerd",
    badge_delete_success: "Waspas verwijderd",
    badge_delete_title: "Verwijder waspas",
    badge_delete_text: "Bent u zeker dat u de waspas wilt verwijderen?",

    //Number plate
    add_numberplate_text: "Nummerplaat toevoegen",
    edit_numberplate_text: "Wijzig nummerplaat",
    enter_number_plate: "Geef nummerplaat in",
    numberplate_reference: "Referentie / naam",
    numberplate_select_fixed_program: "Vast wasprogramma",
    clear_fixed_program: "ik kies mijn programma aan de kiosk",
    numberplate_add: "Toevoegen",
    numberplate_update: "Wijzigen",
    my_numberplate: "Mijn nummerplaten",
    numberplate_header: "Nummerplaat",
    numberplate_reference_header: "Referentie",
    numberplate_fixed_washing_program_header: "Vast wasprogramma",
    numberplate_deactivate_header: "(De)activeer",
    numberplate_already_exist: "Nummerplaat is al in gebruik",
    numberplate_added: "Nummerplaat toegevoegd",
    numberplate_updated: "Nummerplaat gewijzigd",
    numberplate_activate: "Nummerplaat geactiveerd",
    numberplate_deactivate: "Nummerplaat gedeactiveerd",
    numberplate_delete_success: "Nummerplaat verwijderd",
    numberplate_delete_title: "Verwijder nummerplaat",
    numberplate_delete_text:
      "Bent u zeker dat u deze nummerplaat wilt verwijderen?",

    //Transaction
    date_header: "Datum",
    amount_header: "Bedrag",
    free_header: "Gratis",
    paid_header: "Betaald",
    token_header: "Tokens",
    payment_header: "Betaal methode",
    validity_header: "Geldigheidsduur",
    tr_service_header: "Dienst",
    tr_numberplate_header: "Nummerplaat/Waspas",
    tr_reference_header: "Referentie",
    invoice_header: "Factuur",
    ticket_header: "Ticket",
    search_by_amount: "Zoek op bedrag",
    search_by_payment: "Zoek op betaalmethode",
    search_by_from_date: "Vanaf datum",
    search_by_till_date: "Tot datum",
    search_by_service: "Zoek op service",
    search_by_location: "Zoek op locatie",
    search_by_numberplate: "Zoek op nummerplaat",
    search_by_badge: "Zoek op waspas",
    search_by_reference: "Zoek op referentie",

    // Common
    payment_server_message: "Betaal Gateway Server Down",
    common_fail_message: "Er ging iets verkeerd",
    search: "Zoeken",
    copy: "Kopiëren",
    copied: "Gekopieerd",
    members: "Members",
    admin: "Admin",
    guest: "Guest",
    owner: "Owner",
    you: "You",
    invalid: "Invalid",
    not_assigned: "Not Assigned",
    notes: "Notes",
    term: "Term",
    by: "By",
    general: "General",

    // Common Validations
    required: "Verplicht",
    invalid_email: "Ongeldig e-mailadres",
    invalid_phone: "Ongeldig telefoonnummer",
    invalid_date: "Invalid date",
    invalid_url: "Invalid url",
    invalid_fb_url: "Invalid facebook url",
    invalid_linkedin_url: "Invalid linkedin url",
    invalid_twitter_url: "Invalid twitter url",
    required_terms_condition: "Check the terms & conditions.!",
    invalid_profile_image_size:
      "Image is smaller than recommended image, upload another image.",
    csv_file_not_parsed: "Could not parse file.",
    check_terms: "Gelieve akkoord te gaan met de algemene voorwaarden.",
    conf_password_not_match: "Confirm password not matched",

    select: "Selecteren",

    logout_confirmation_title: "Afmelden",
    logout_confirmation_text: "Do you really want to logout?",

    // Buttons
    button_login: "Inloggen",
    button_signup: "Aanmelden",
    button_logout: "Logout",
    button_save: "Save",
    button_close: "Close",
    button_cancel: "Cancel",
    button_edit: "Edit",
    button_delete: "Delete",
    button_back: "Back",
    button_yes: "Ja",
    button_no: "Nee",
    button_previous: "Vorige",
    button_next: "Volgende",
    button_finish: "Finish",
    button_remove: "Remove",
    button_download: "Download",
    button_import: "Import",
    button_send_invite: "Send Invite",
    button_enroll_member: "Enroll Member",
    button_options: "Options",
    button_crop: "Crop",
    button_make_admin: "Make Admin",
    button_remove_admin: "Remove Admin",
    button_edit_profile: "Edit Profile",
    button_assessment: "Assessment",
    button_practice: "Practice",
    button_invite: "Invite",
    button_notify_class: "Notify Class",
    button_end_quiz: "End Quiz",
    button_skip: "Skip",
    button_correct: "Correct",
    button_incorrect: "Incorrect",
    button_retake_quiz: "Retake Quiz",

    // Login & Signup
    facebook_signin: "Sign in with Facebook",
    twitter_signin: "Sign in with Twitter",
    google_signin: "Sign in with Google",

    login_common_text_or_login_with: "Or continue with",

    login_title_login: "Inloggen",
    login_form_label_email: "Email/Badge",
    login_form_ph_email: "Enter your email address",
    login_form_label_password: "Password",
    login_form_ph_password: "Enter your password",
    login_form_label_rememberme: "Remember me",
    login_text_forgot_password: "Forgot your password",
    login_text_dont_have_account: "Hebt u nog geen account?",
    login_error_text_invalid_email_password: "Invalid email or password!",
    login_error_text_company_login: "You are not authorized to loggedin here",
    logout_confirmation_title: "Afmelden",
    logout_confirmation_text: "Ben je zeker dat je wil afmelden?",

    reset_password_form_label_conf_password: "Confirm Password",
    reset_password_ph_label_conf_password: "Enter confirm password",

    reset_password_form_label_code: "Code",
    reset_password_ph_label_code: "Enter code",

    //Reset PASSWORD
    reset_password: "Password opnieuw instellen",
    forgot_password: "Forgot Password",
    reset_password_send: "Send",
    reset_password_success:
      "We have sent you an email with a confirmation code and reset link.",
    more: "Meer",
    company_info_save_success: "Bedrijfsinformatie succesvol bewaard.",
    personal_info_save_success: "Persoonlijke informatie succesvol bewaard.",
    credit_amount: "Bedrag",
    free: "gratis",
    terms_first: "Ik accepteer de",
    terms_second: "algemene voorwaarden",

    invalid_amount: "Voer alleen het nummer in",

    reset_password_update_success: "Password updated successfully.",
  },
  fr: {
    country: "Country",
    //Login
    welcome_text: "Welcome back to ",
    enter_login_details_text: "Enter your login details",

    //Signup
    signup_title_signup: "Signup",
    signup_subtitle: "Lets get started.Enter your details.",
    signup_form_label_fullname: "Fullname",
    signup_form_label_email: "Email/Badge",
    signup_form_label_password: "Password",
    signup_form_label_confpassword: "Confirm password",
    signup_form_validation_min_password: "Please enter minimum 6 char",
    signup_form_validation_conf_password:
      "Password and Confirm Password does not match",
    signup_error_registration_failed: "Your registration failed, try again!",
    signup_error_check_age_conditions: "Please check the age!",
    signup_text_already_an_account: "Already have an account?",
    signup_form_label_age: "I am above 18 years old",

    signup_user_form_label_username: "What do your student call you?",
    signup_user_form_ph_fname: "Enter your first name",
    signup_user_form_ph_lname: "Enter your last name",
    signup_user_stu_form_label_username: "What do your teacher call you?",
    signup_user_stu_form_ph_username: "Enter your display name",
    signup_user_form_success: "Details saved successfully!",
    signup_user_button_logout: "I'll save later. Logout",

    // Menu
    dashboard: "Dashboard",
    personalinfo: "Personal information",
    badges: "Badges",
    numberplate: "Manage number plate",
    mytransaction: "My transactions",
    profile: "Your Profile",
    logout: "Logout",
    balance_text: "Balance",
    valid_until: "Valid Until",
    welcome: "Welcome",
    termsnconditions: "Terms & conditions",
    privacypolicy: "Privacy policy",
    userid: "Userid",

    //Dashboard
    charge_credit: "Charge Credit",
    number_plates: "Number Plates",
    badges: "Badges",
    my_transaction: "My Transactions",
    manage_numberplate: "Manage number plate",
    manage_badge: "Manage badges",
    make_payment_heading: "Payment",
    make_payment_btn: "Make Payment",
    view_all: "View All",
    enter_amount: "Enter amount",
    bought: "Bought",
    spent: "Spent",

    //Personal info
    personal_info_title: "Personal Information",
    invoice_info_title: "Invoice Information",
    personalinfo_form_label_address: "Address",
    personalinfo_form_label_lowcredit_notify_title:
      "I want to receive an email when my credit is low",
    personalinfo_form_label_lowcredit_notify_amount:
      "Email when credit is below",
    personalinfo_form_label_i_am_company: "I am a company",
    personalinfo_form_label_company_name: "Company Name",
    personalinfo_form_label_tva_number: "TVA Number",
    personalinfo_form_label_phone_number: "Phone Number",
    personalinfo_form_label_billing_address: "Billing Address",
    personalinfo_form_label_country: "Country",
    personalinfo_form_label_notify_invoice:
      "I want to receive an invoice via email with every payment made.",
    personalinfo_form_label_invoice_email: "Invoicing Email",
    save_changes: "Save Changes",
    change_password_heading: "Change Password",
    change_password_btn: "Change Password",
    change_password_save: "Update",
    password_setting_form_label_old_password: "Old Password",
    password_setting_form_ph_old_password: "Enter old password",
    password_setting_form_label_new_password: "New Password",
    password_setting_form_ph_new_password: "Enter new password",
    password_setting_form_label_repeat_password: "Repeat Password",
    password_setting_form_ph_repeat_password: "Enter new password",
    password_setting_form_success: "Password updated successfully",
    password_setting_form_old_password_error: "Password reset failed",
    password_setting_form_validation_repeat_password_required:
      "Password does not match",
    password_setting_form_validation_repeat_old_password_not_match:
      "Repeat password does not match with password",
    users_additional_form_label_address: "Address",

    // Badges
    add_badge_text: "Add Badge",
    edit_badge_text: "Edit Badge",
    enter_badge_number: "Enter badge number",
    reference: "Reference / Name",
    select_fixed_program: "Select fixed program",
    badge_add: "Add",
    badge_update: "Update",
    my_badges: "My Badges",
    badge_header: "Badge",
    reference_header: "Reference",
    fixed_washing_program_header: "Fixed washing program",
    deactivate_header: "De(activate)",
    badge_already_exist: "Badge already exist",
    badge_added: "Badge added successfully",
    badge_updated: "Badge updated successfully",
    badge_activate: "Badge activated successfully",
    badge_deactivate: "Badge deactivated successfully",
    badge_delete_success: "Badge deleted successfully",
    badge_delete_title: "Delete Badge",
    badge_delete_text: "Are you sure. Continue?",

    //Number plate
    add_numberplate_text: "Add Numberplate",
    edit_numberplate_text: "Edit Numberplate",
    enter_number_plate: "Enter number plate",
    numberplate_reference: "Reference / Name",
    numberplate_select_fixed_program: "Fixed washing program",
    clear_fixed_program: "I choose my program on the terminal",
    numberplate_add: "Add",
    numberplate_update: "Update",
    my_numberplate: "My Numberplates",
    numberplate_header: "Numberplate",
    numberplate_reference_header: "Reference",
    numberplate_fixed_washing_program_header: "Fixed washing program",
    numberplate_deactivate_header: "De(activate)",
    numberplate_already_exist: "Numberplate already exist",
    numberplate_added: "Numberplate added successfully",
    numberplate_updated: "Numberplate updated successfully",
    numberplate_activate: "Numberplate activated successfully",
    numberplate_deactivate: "Numberplate deactivated successfully",
    numberplate_delete_success: "Numberplate deleted successfully",
    numberplate_delete_title: "Delete Numberplate",
    numberplate_delete_text: "Are you sure. Continue?",

    //Transaction
    date_header: "Date",
    amount_header: "Amount",
    free_header: "Free",
    paid_header: "Paid",
    token_header: "Tokens",
    payment_header: "Payment method",
    validity_header: "Validity",
    tr_service_header: "Service",
    tr_numberplate_header: "Numberplate/Badge",
    tr_reference_header: "Reference",
    invoice_header: "Invoice",
    ticket_header: "Ticket",
    search_by_amount: "Search by amount",
    search_by_payment: "Search by payment method",
    search_by_from_date: "From date",
    search_by_till_date: "Till date",
    search_by_service: "Search by service",
    search_by_location: "Search by location",
    search_by_numberplate: "Search by numberplate",
    search_by_badge: "Search by badge",
    search_by_reference: "Search by reference",

    // Common
    payment_server_message: "Payment Gateway Server Down!",
    common_fail_message: "Something went wrong!",
    search: "Search",
    copy: "Copy",
    copied: "Copied",
    members: "Members",
    admin: "Admin",
    guest: "Guest",
    owner: "Owner",
    you: "You",
    invalid: "Invalid",
    not_assigned: "Not Assigned",
    notes: "Notes",
    term: "Term",
    by: "By",
    general: "General",

    // Common Validations
    required: "Required",
    invalid_email: "Invalid email",
    invalid_phone: "Invalid phone",
    invalid_date: "Invalid date",
    invalid_url: "Invalid url",
    invalid_fb_url: "Invalid facebook url",
    invalid_linkedin_url: "Invalid linkedin url",
    invalid_twitter_url: "Invalid twitter url",
    required_terms_condition: "Check the terms & conditions.!",
    invalid_profile_image_size:
      "Image is smaller than recommended image, upload another image.",
    csv_file_not_parsed: "Could not parse file.",
    check_terms: "Please check terms & conditions",
    conf_password_not_match: "Confirm password not matched",

    // Buttons
    button_login: "Sign In",
    button_signup: "Sign Up",
    button_logout: "Logout",
    button_save: "Save",
    button_close: "Close",
    button_cancel: "Cancel",
    button_edit: "Edit",
    button_delete: "Delete",
    button_back: "Back",
    button_yes: "Yes",
    button_no: "No",
    button_previous: "Previous",
    button_next: "Next",
    button_finish: "Finish",
    button_remove: "Remove",
    button_download: "Download",
    button_import: "Import",
    button_send_invite: "Send Invite",
    button_enroll_member: "Enroll Member",
    button_options: "Options",
    button_crop: "Crop",
    button_make_admin: "Make Admin",
    button_remove_admin: "Remove Admin",
    button_edit_profile: "Edit Profile",
    button_assessment: "Assessment",
    button_practice: "Practice",
    button_invite: "Invite",
    button_notify_class: "Notify Class",
    button_end_quiz: "End Quiz",
    button_skip: "Skip",
    button_correct: "Correct",
    button_incorrect: "Incorrect",
    button_retake_quiz: "Retake Quiz",

    // Login & Signup
    facebook_signin: "Sign in with Facebook",
    twitter_signin: "Sign in with Twitter",
    google_signin: "Sign in with Google",

    login_common_text_or_login_with: "Or continue with",

    login_title_login: "Login",
    login_form_label_email: "Email/Badge",
    login_form_ph_email: "Enter your email address",
    login_form_label_password: "Password",
    login_form_ph_password: "Enter your password",
    login_form_label_rememberme: "Remember me",
    login_text_forgot_password: "Forgot your password",
    login_text_dont_have_account: "Don't have an account?",
    login_error_text_invalid_email_password: "Invalid email or password!",
    login_error_text_company_login: "You are not authorized to loggedin here",
    logout_confirmation_title: "Logout",
    logout_confirmation_text: "Do you really want to logout?",

    //Reset PASSWORD
    reset_password: "Reset Password",
    forgot_password: "Forgot Password",
    reset_password_send: "Send",
    reset_password_success:
      "We have sent you an email with a confirmation code and reset link.",

    select: "Select",

    signup_agree_text: "By continuing you are agree to our",
    signup_terms_text: "Terms of Use",
    signup_and: "and",
    signup_privacy: "Privacy Policy",
    more: "More",
    personal_info_save_success: "Personal info saved successfully.",
    company_info_save_success: "Company info saved successfully.",
    credit_amount: "Credit Amount",
    free: "free",
    terms_first: "I accept the",
    terms_second: "terms & conditions",

    invalid_amount: "Enter only number",
    reset_password_update_success: "Password updated successfully.",
  },
});

export default LocaleStrings;
